<section class="w-full">
  <split-header-section
    title="Relatório de Notas Fiscais"
  ></split-header-section>

  <div>
    <split-filter-menu
      (filterEvent)="addFilterOptions($event)"
    ></split-filter-menu>
  </div>

  <form
    class="w-full mt-5"
    [style.padding-left]="'16.002px'"
    [style.padding-right]="'16.002px'"
  >
    <div class="grid mt-5">
      <div class="col">
        <div class="bg-white p-5 border-round-2xl box-shadow">
          <div class="header mb-5">
            <span class="title"> Economia mês a mês </span> <br />
            <span class="subtitle"
              >Gráfico relacionado aos últimos 12 meses</span
            >
          </div>

          <div class="w-full">
            <div class="valores_mes flex mb-4">
              <div class="mes_atual flex flex-column align-items-start pr-3">
                {{
                  form.value.economia_mes_a_mes![11].data
                    | currency : "BRL" : "symbol" : "1.2-2"
                }}
                <!-- <span class="subtitle"> Mês atual </span> -->
                <span class="subtitle"> Imposto com split </span>
              </div>
              <div
                class="mes_anterior flex flex-column align-items-start justify-content-center pl-3"
              >
                {{
                  form.value.economia_mes_a_mes![10].data
                    | currency : "BRL" : "symbol" : "1.2-2"
                }}
                <span class="subtitle"> Imposto sem split </span>
              </div>
            </div>

            <split-line
              [data]="chartData"
              [labels]="chartLabel"
              [allowLegend]="false"
              [highlightLastLabel]="true"
              [reduceLabels]="false"
            >
            </split-line>
          </div>
        </div>
      </div>
    </div>

    <div class="grid mt-5">
      <div class="col">
        <div class="bg-white p-5 border-round-2xl box-shadow">
          <div class="header mb-6">
            <span class="title"> Notas fiscais emitidas para clínica </span> <br />
          </div>

          <div class="w-full">
            <div class="mt-5">
              <split-report-table
                [data]="form.value.notas_fiscais_empresa"
                [widthColumns]="[
                  '20',
                  '15',
                  '15',
                  '10',
                  
                  '10',
                  '10',
                  '20'
                ]"
              >
                <ng-template #header>
                  <div class="text-left pl-5">Empresa</div>
                </ng-template>
                <ng-template #column let-row="row">
                  <div class="text-left pl-5 primary_font_style">
                    {{ row?.nome_unidade }}
                  </div>
                </ng-template>

                <ng-template #header> Atendimentos </ng-template>
                <ng-template #column let-row="row">
                  {{ row?.qtd_atendimentos }}
                </ng-template>

                <ng-template #header>
                  NF emissão <br />
                  automática
                </ng-template>
                <ng-template #column let-row="row">{{
                  row?.NF_automatica ? "Sim" : "Não"
                }}</ng-template>

                <ng-template #header> NF emitida </ng-template>
                <ng-template #column let-row="row">{{
                  row?.qtd_NF_emitidas
                }}</ng-template>

                <!-- <ng-template #header> NF contabilidade </ng-template>
                <ng-template #column let-row="row">{{
                  row?.qtd_NF_contabilidade
                }}</ng-template> -->

                <ng-template #header> Erro </ng-template>
                <ng-template #column let-row="row">{{
                  row?.qte_erro
                }}</ng-template>

                <ng-template #header> Valor notas </ng-template>
                <ng-template #column let-row="row">
                  R${{ row?.valor_notas }}
                </ng-template>

                <ng-template #header>
                  <div class="pr-5">
                    Comparativo <br />
                    notas mês ant.
                  </div>
                </ng-template>
                <ng-template #column let-row="row">
                  <div class="pr-5">
                    {{ row?.comparativo_notas_mes_anterios_porcentagem }}%
                  </div>
                </ng-template>
              </split-report-table>
            </div>

            <div *ngIf="form.value.notas_fiscais_empresa!.length > 1" class="mt-5 mb-5">
              <div class="header flex">
                <span class="title">Total</span>
              </div>
              <div class="mt-3">
                <div class="flex p-4 total">
                  <div style="width: 15%" class="text-left primary_font_style">
                    Todos
                  </div>
                  <div style="width: 8%" class="text-center">
                    {{
                      form.value.total_notas_ficais_profissionais
                        ?.total_qtd_atendimentos
                    }}
                  </div>
                  <div style="width: 10%" class="text-center"></div>
                  <div style="width: 10%" class="text-center">
                    {{
                      form.value.total_notas_ficais_profissionais
                        ?.total_qtd_NF_emitidas
                    }}
                  </div>
                  <div style="width: 10%" class="text-center">
                    {{
                      form.value.total_notas_ficais_profissionais
                        ?.total_qtd_NF_contabilidade
                    }}
                  </div>
                  <div style="width: 7%" class="text-center">
                    {{
                      form.value.total_notas_ficais_profissionais?.total_qte_erro
                    }}
                  </div>
                  <div style="width: 10%" class="text-center">
                    R${{
                      form.value.total_notas_ficais_profissionais
                        ?.total_valor_notas
                    }}
                  </div>
                  <div style="width: 10%" class="text-center">
                    R${{
                      form.value.total_notas_ficais_profissionais
                        ?.total_valor_economia_IR
                    }}
                  </div>
                  <div style="width: 13%" class="text-center">
                    {{
                      form.value.total_notas_ficais_profissionais
                        ?.total_comparativo_notas_mes_anterios_porcentagem
                    }}%
                  </div>
                  <div style="width: 5%" class="text-center"></div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="grid mt-5">
      <div class="col">
        <div class="bg-white p-5 border-round-2xl box-shadow">
          <div class="header mb-6 flex justify-content-between">
            <div>
              <span class="title"> Notas fiscais profissional </span> <br />
            </div>
            <div class="flex align-items-center">
              <button
                (click)="removeFilterEmissao()"
                class="clear_filter mr-4"
                *ngIf="applyFilterEmissao"
              >
                Limpar filtro
              </button>
              <div [ngClass]="applyFilterEmissao ? 'filter-applied' : 'filter'">
                <p-menu #menu [model]="filtroEmissao" [popup]="true"></p-menu>
                <button
                  pButton
                  type="button"
                  (click)="menu.toggle($event)"
                  label="NF emissão automática"
                ></button>
              </div>
            </div>
          </div>

          <div class="mt-5">
            <split-report-table
              [data]="form.value.notas_fiscais_profissional"
              [widthColumns]="[
                '15',
                '10',
                '10',
                '10',
                '10',
                '7',
                '10',
                '10',
                '13',
                '5'
              ]"
            >
              <ng-template #header>
                <div class="text-left pl-5">Profissional</div>
              </ng-template>
              <ng-template #column let-row="row">
                <div class="text-left pl-5 primary_font_style">
                  {{ row?.nome_profissional }}
                </div>
              </ng-template>

              <ng-template #header> Atendimentos </ng-template>
              <ng-template #column let-row="row">
                {{ row?.qtd_atendimentos }}
              </ng-template>

              <ng-template #header>
                NF emissão <br />
                automática
              </ng-template>
              <ng-template #column let-row="row">{{
                row?.NF_automatica ? "Sim" : "Não"
              }}</ng-template>

              <ng-template #header> NF emitida </ng-template>
              <ng-template #column let-row="row">{{
                row?.qtd_NF_emitidas
              }}</ng-template>

              <ng-template #header>
                NF <br />
                contabilidade
              </ng-template>
              <ng-template #column let-row="row">{{
                row?.qtd_NF_contabilidade
              }}</ng-template>

              <ng-template #header> Erro </ng-template>
              <ng-template #column let-row="row">{{
                row?.qtd_erro
              }}</ng-template>

              <ng-template #header> Valor notas </ng-template>
              <ng-template #column let-row="row">
                R${{ row?.valor_notas }}
              </ng-template>

              <ng-template #header>
                Valor economia IR da Clinica
              </ng-template>
              <ng-template #column let-row="row">
                R${{ row?.valor_economia_IR }}
              </ng-template>

              <ng-template #header>
                Comparativo <br />
                notas mês ant.
              </ng-template>
              <ng-template #column let-row="row">
                {{ row?.comparativo_notas_mes_anterior_porcentagem }}%
              </ng-template>

              <ng-template #header>
                <!-- <div class="pr-5">
                    actions
                  </div> -->
              </ng-template>
              <ng-template #column let-row="row">
                <button
                  (click)="
                    openReportByEmployee(row?.nome_profissional, row?.notas)
                  "
                  class="border-none"
                  style="background-color: rgba(0, 0, 0, 0)"
                >
                  <split-icon name="playlist-add"></split-icon>
                </button>
              </ng-template>
            </split-report-table>
          </div>

          <div class="mt-5 mb-5">
            <div class="header flex">
              <span class="title">Total</span>
            </div>
            <div class="mt-3">
              <div class="flex p-4 total">
                <div style="width: 15%" class="text-left primary_font_style">
                  Todos
                </div>
                <div style="width: 8%" class="text-center">
                  {{
                    form.value.total_notas_ficais_profissionais
                      ?.total_qtd_atendimentos
                  }}
                </div>
                <div style="width: 10%" class="text-center"></div>
                <div style="width: 10%" class="text-center">
                  {{
                    form.value.total_notas_ficais_profissionais
                      ?.total_qtd_NF_emitidas
                  }}
                </div>
                <div style="width: 10%" class="text-center">
                  {{
                    form.value.total_notas_ficais_profissionais
                      ?.total_qtd_NF_contabilidade
                  }}
                </div>
                <div style="width: 7%" class="text-center">
                  {{
                    form.value.total_notas_ficais_profissionais?.total_qte_erro
                  }}
                </div>
                <div style="width: 10%" class="text-center">
                  R${{
                    form.value.total_notas_ficais_profissionais
                      ?.total_valor_notas
                  }}
                </div>
                <div style="width: 10%" class="text-center">
                  R${{
                    form.value.total_notas_ficais_profissionais
                      ?.total_valor_economia_IR
                  }}
                </div>
                <div style="width: 13%" class="text-center">
                  {{
                    form.value.total_notas_ficais_profissionais
                      ?.total_comparativo_notas_mes_anterios_porcentagem
                  }}%
                </div>
                <div style="width: 5%" class="text-center"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="grid mt-5 mb-7">
      <div class="col">
        <div class="bg-white p-5 border-round-2xl box-shadow">
          <div class="header mb-5">
            <span class="title"> Empresa </span> <br />
            <span class="subtitle">{{
              form.value.notas_fiscais_empresa![0].nome_unidade
            }}</span>
          </div>

          <div class="w-full">
            <div
              class="emitidas flex align-items-center py-3 px-4 border-round-2xl"
            >
              <span class="primary mr-3">
                {{ this.form.value.notas_fiscais_empresa![0].qtd_NF_emitidas }}
              </span>
              Notas fiscais emitidas
            </div>

            <div
              class="erro mt-5 flex align-items-center py-3 px-4 border-round-2xl"
            >
              <span class="primary mr-3">
                {{ this.form.value.notas_fiscais_empresa![0].qte_erro }}
              </span>
              Notas fiscais com erro
            </div>
            <div
              class="sucesso my-5 flex align-items-center py-3 px-4 border-round-2xl"
            >
              <span class="primary mr-3">
                {{ this.form.value.notas_fiscais_empresa![0].valor_notas }}
              </span>
              Valor total
            </div>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="bg-white p-5 border-round-2xl box-shadow">
          <div class="header mb-5 flex justify-content-between">
            <div>
              <span class="title"> Profissionais </span> <br />
              <!-- <div *ngIf="applyFilterProfissional; else allEmployeesMessage">
                <span class="filter_professional_applied">
                  {{ selectedEmployeeFilter }}
                </span>
              </div>-->
              <ng-container *ngIf="!professionalFilteredId" >
                <span class="subtitle">Todos os profissionais</span>
              </ng-container> 
            </div>
            <!-- <div
              [ngClass]="applyFilterProfissional ? 'filter-applied' : 'filter'"
            >
              <p-menu
                #menuProfissional
                [model]="professionalFilterOptions"
                [popup]="true"
              ></p-menu>
              <button
                pButton
                type="button"
                (click)="menuProfissional.toggle($event)"
                label="Profissional"
              ></button>
            </div> -->

            <div>
              <p-dropdown
              styleClass="filterDropdown"
                [(ngModel)]="professionalFilteredId"
                [options]="professionalFilterOptions"
                optionLabel="name"
                optionValue="id"
                placeholder="Filtrar Profissional"
                (onChange)="addFilterProfissional()"
                [filter]="true"
                filterBy="name"
                [showClear]="true" 
                [ngModelOptions]="{standalone: true}"
              />
            </div>
          </div>

          <div class="w-full">
            <div
              class="emitidas flex align-items-center py-3 px-4 border-round-2xl"
            >
              <span class="primary mr-3">
                {{
                  this.form.value.total_notas_ficais_profissionais
                    ?.total_qtd_NF_emitidas
                }}
              </span>
              Notas fiscais emitidas
            </div>

            <div
              class="erro mt-5 flex align-items-center py-3 px-4 border-round-2xl"
            >
              <span class="primary mr-3">
                {{
                  this.form.value.total_notas_ficais_profissionais
                    ?.total_qte_erro
                }}
              </span>
              Notas fiscais com erro
            </div>
            <div
              class="sucesso my-5 flex align-items-center py-3 px-4 border-round-2xl"
            >
              <span class="primary mr-3">
                {{
                  this.form.value.total_notas_ficais_profissionais
                    ?.total_valor_notas
                }}
              </span>
              Valor total
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</section>
